// Route guards for role-restricted pages. They only improve UX (no flash of
// a page that would fail with permission-denied): the Firestore rules and
// the callable Functions are the real boundary.
import type { Rol } from '@taller/shared';
import { redirect } from '@tanstack/react-router';
import type { SesionActiva } from './sesion';

export function exigir(permiso: (r: Rol) => boolean) {
  return ({ context }: { context: { sesion: SesionActiva } }) => {
    if (!permiso(context.sesion.rol)) throw redirect({ to: '/', replace: true });
  };
}
